import React from 'react';

const Buttons = (props) => {
  return (
    <a
      href="/"
      className="group relative flex items-center justify-center gap-[10px] min-w-[197px] p-[4px]  h-[60px] text-[16px] text-white no-underline rounded-[40px] overflow-hidden backdrop-blur-[15px] bg-[#5A5858] transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)] border-t-[2px] border-l-[2px] border-[#B1B0B0] border-solid hover:bg-[rgba(0,0,0,0.55)]"
    >
      <div className="flex items-center gap-0 h-full relative pe-[33px] py-17 ps-[4px] group-hover:ps-[20px] transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)] z-10 w-full">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[#F2BA35] rounded-[50px] z-0 group-hover:w-[8px] group-hover:h-[8px] group-hover:left-[38px]  group-hover:top-1/2 transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)]"></div>

        <div className="relative w-[36px] h-[36px] opacity-0 group-hover:opacity-100 transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)]">
          <div className="absolute top-1/2 left-1/2 w-[28px] h-[28px] bg-[#FF000D] rounded-[91%] -translate-x-1/2 -translate-y-1/2 group-hover:w-[10px] group-hover:h-[10px] transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)]"></div>
        </div>

        <div className="text-white text-[20px] min-w-[120px] text-center block select-none whitespace-pre z-10 font-semibold">
          {props.label}
        </div>
      </div>
    </a>
  );
};

export default Buttons;
